import PropTypes from 'prop-types';
import { IonCol, IonRow } from '@ionic/react';
import ProfileFieldInputMob from './ProfileFieldInputMob';
import { getProfileFieldRowState } from './profileFieldGridHelpers';
import {
  memberProfileFieldKey,
  filterProfileFieldsForCartUser,
} from './profileFieldFormUtils';

/**
 * Ionic checkout cart profile fields keyed by memberProfileFieldKey.
 */
const CheckoutProfileFieldsGridMob = ({
  profileFields,
  userId,
  formValues,
  formSubmitted,
  onFieldChange,
  cartData,
  packageProductData,
  isItemMatching,
  fieldErrors,
}) => {
  const fields = filterProfileFieldsForCartUser(
    profileFields,
    userId,
    cartData,
    packageProductData,
    isItemMatching,
  );

  if (!fields.length) {
    return null;
  }

  return fields.map((field) => {
    const formKey = memberProfileFieldKey(userId, field);
    const { displayValue, helperText, hasError } = getProfileFieldRowState(
      field,
      formValues[formKey],
      formSubmitted,
      fieldErrors,
      formKey,
    );

    return (
      <IonRow key={formKey}>
        <IonCol size='12'>
          <ProfileFieldInputMob
            field={field}
            value={displayValue}
            onChange={(_field, value) => onFieldChange(formKey, value)}
            error={hasError}
            helperText={helperText}
          />
          <input
            type='hidden'
            name={`${userId}-${field.profile_field_name}`}
            value={field.profile_field_name}
            readOnly
          />
        </IonCol>
      </IonRow>
    );
  });
};

CheckoutProfileFieldsGridMob.propTypes = {
  profileFields: PropTypes.array,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  formValues: PropTypes.object,
  formSubmitted: PropTypes.bool,
  onFieldChange: PropTypes.func.isRequired,
  cartData: PropTypes.array,
  packageProductData: PropTypes.array,
  isItemMatching: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object,
};

export default CheckoutProfileFieldsGridMob;
